import * as React from "react";
import { List, ArrayField, Datagrid, SingleFieldList, ChipField, TextField, EmailField, EditButton, DeleteButton } from 'react-admin';
import SimpleChipField from './custom/SimpleChipField';

export const RuleList = props => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="_id" />
      <TextField source="title" />
      <TextField source="field_label" />
      <ArrayField source="entries_value">
        <SingleFieldList>
          <SimpleChipField />
        </SingleFieldList>
      </ArrayField>
      <EditButton basePath="/rules" />
      <DeleteButton basePath="/rules" />
    </Datagrid>
  </List>
);
